import { KendoBaseComponent, KendoBaseDatasourceComponent } from '@progress/kendo-base-components-vue-wrapper'
import ChartProps from './ChartProps'
import KendoChartSeriesItem from '../KendoChartSeriesItem'
import AxisDefaults from './AxisDefaults'
import CategoryAxis from './CategoryAxis'
import ChartArea from './ChartArea'
import Legend from './Legend'
import Panes from './Panes'
import Pannable from './Pannable'
import Pdf from './Pdf'
import PlotArea from './PlotArea'
import Series from './Series'
import SeriesDefaults from './SeriesDefaults'
import Title from './Title'
import Tooltip from './Tooltip'
import ValueAxis from './ValueAxis'
import XAxis from './XAxis'
import YAxis from './YAxis'
import Zoomable from './Zoomable'

export default {
    props: ChartProps,
    render (h) {
        return h('div',this.$slots.default)
    },
    mixins: [
        KendoBaseComponent,
        KendoBaseDatasourceComponent,
        AxisDefaults,
        CategoryAxis,
        ChartArea,
        Legend,
        Panes,
        Pannable,
        Pdf,
        PlotArea,
        Series,
        SeriesDefaults,
        Title,
        Tooltip,
        ValueAxis,
        XAxis,
        YAxis,
        Zoomable
    ],
    mounted() {
        this._resolveChildren()
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoChart()
        },
        _resolveChildren() {
            this.resolveChildren('series', KendoChartSeriesItem.name)
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoChartBase/KendoChartMixinBase.js